import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** Formateadores numéricos del idioma activo: enteros y con un decimal. */
export function useNumberFormats() {
  const { i18n } = useTranslation();
  const number = useMemo(() => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 0 }), [i18n.language]);
  const decimal = useMemo(() => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 1 }), [i18n.language]);
  return { number, decimal };
}
